const NO_SLA_CODE = "No SLA";

export const isSlaInvalid = (slaCode: string): boolean => !slaCode || slaCode === NO_SLA_CODE;
